<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">管理员管理</el-breadcrumb-item>
      <el-breadcrumb-item>管理员修改</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :data="formData" label-width="160px">
          <el-form-item label="管理员姓名">
            <el-col :span="12">
              <el-input size="small" v-model="formData.realname" disabled></el-input>
            </el-col>
            <el-col :span="12">
              <span class="tips">*真实姓名，不可以修改</span>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号">
            <el-col :span="12">
              <el-input size="small" v-model="formData.mobile" disabled></el-input>
            </el-col>
            <el-col :span="12">
              <span class="tips">*不可修改</span>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-col :span="12">
              <el-input size="small" v-model="formData.email" placeholder="请输入邮箱"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="登录名">
            <el-col :span="12">
              <el-input size="small" v-model="formData.login_name" disabled></el-input>
            </el-col>
            <el-col :span="12">
              <span class="tips">*不可修改</span>
            </el-col>
          </el-form-item>
          <el-form-item label="登录密码">
            <el-col :span="12">
              <el-input size="small" type="password" v-model="formData.password"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="确认登录密码">
            <el-col :span="12">
              <el-input size="small" type="password" v-model="formData.repassword"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="权限组">
            <el-col :span="12">
              <el-select
                 size="small"
                v-model="formData.show_group_ids"
                multiple
                placeholder="请选择"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in group"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        id: "",
        realname: "",
        mobile: "",
        email: "",
        login_name: "",
        password: "",
        repassword: "",
        show_group_ids: [],
        group_ids: []
      },
      group: []
    };
  },
  methods: {
    save() {
      let _formData = this.formData;
      if (_formData.email == "") {
        this.$util.msg("请输入邮箱");
      } else if (
        _formData.password != "" &&
        _formData.repassword != _formData.password
      ) {
        this.$util.msg("两次密码输入不一致");
      } else if (_formData.show_group_ids.length == 0) {
        this.$util.msg("请选择权限组");
      } else {
        _formData.group_ids = _formData.show_group_ids.join(",");
        this.$ajax({
          loading: true,
          type: "post",
          url: "/admin/save",
          data: _formData
        }).then(data => {
          this.$util.msg(data.msg, "success");
          setTimeout(() => {
            this.$router.push({ path: "/admin/index" });
          }, 1200);
        });
      }
    }
  },
  mounted() {
    this.formData.id = this.$route.query.id;
    this.$ajax({
      url: "/admin/get-role"
    }).then(data => {
      this.group = data.data;
    });

    this.$ajax({
      loading: true,
      url: "/admin/one",
      data: {
        id: this.formData.id
      }
    }).then(data => {
      let _data = data.data.admin;
      this.formData.realname = _data.realname;
      this.formData.mobile = _data.mobile;
      this.formData.email = _data.email;
      this.formData.login_name = _data.login_name;
      this.formData.show_group_ids = data.data.group_id;
    });
  }
};
</script>
<style>
</style>